import { Prisma } from '@prisma/client';
import { useFetcher, useLoaderData } from 'react-router';
import ConfirmButtonForm from '~/components/ConfirmButtonForm';
import TeamRadialSelector from '~/components/TeamRadialSelector';
import { loader } from './_route';

export default function DraftPlayerItem({
  player,
}: {
  player: Prisma.PlayerGetPayload<{
    select: {
      id: true;
      name: true;
      role: {
        select: {
          name: true;
        };
      };
      teamId: true;
    };
  }>;
}) {
  const playSession = useLoaderData<typeof loader>();
  const fetcher = useFetcher();
  return (
    <li
      key={player.id}
      className="flex gap-4 justify-between items-center bg-black p-2 px-3 rounded border border-slate-800"
    >
      <fetcher.Form
        method="post"
        className="flex flex-col gap-3"
        action={`/draft/${playSession.slug}?index`}
      >
        <input type="hidden" name="playSessionId" value={playSession?.id} />

        <input type="hidden" name="playerId" value={player.id} />
        <div className="flex items-center justify-between">
          <TeamRadialSelector
            teams={playSession?.teams?.map((team) => ({
              id: team.id,
              name: team.name,
            }))}
            onChange={(teamId) => {
              const formData = new FormData();

              formData.set('teamId', teamId);
              formData.set('playerId', player.id);
              formData.set('intent', 'place-player');
              formData.set('playSessionId', playSession?.id ?? '');

              if (fetcher.state === 'idle') {
                fetcher.submit(formData, {
                  method: 'post',
                  action: `/draft/${playSession.slug}?index`,
                });
              }
            }}
          />
          <input type="hidden" name="intent" value="place-player" />
        </div>
      </fetcher.Form>
      <span className="flex-grow">
        {player.name}{' '}
        {player.role.name === 'any'
          ? '🤷'
          : player.role.name === 'queen'
          ? '👑'
          : '🐝'}
      </span>
      <ConfirmButtonForm
        action={`/draft/${playSession.slug}?index`}
        intent="remove-player"
        buttonChildren={'🗑️'}
      >
        <input type="hidden" name="playerId" value={player.id} />
      </ConfirmButtonForm>
    </li>
  );
}
